// Copyright (c) 2022 VMware, Inc. All rights reserved. -- VMware Confidential

import { Injectable } from "@angular/core";

// @formatter:off
@Injectable({
    providedIn: "root"
})
// @formatter:on
export class LocalStorageService {

    public setObject(key: string, obj: any): void {
        localStorage.setItem(key, JSON.stringify(obj));
    }

    public hasObject(key: string): boolean {
        return localStorage.getItem(key) !== null;
    }

    public getBooleanValue(key: string): boolean {
        return JSON.parse(localStorage.getItem(key));
    }

    public getObject(key: string): any {
        const obj: any = JSON.parse(localStorage.getItem(key));
        return Object.assign({}, obj);
    }

}
